import { observer } from 'mobx-react'
import React, { FC } from 'react'
import RequestsTable from './Table/RequestsTable'

interface RequestsProps {
  openRequestDetails: any
  filterStore: any
}

const Requests: FC<RequestsProps> = ({ openRequestDetails, filterStore }) => {
  return (
    <RequestsTable
      openRequestDetails={openRequestDetails}
      filterStore={filterStore}
    />
  )
}

export default observer(Requests)
